// eslint-disable-next-line import/prefer-default-export
export const SET_VEHICLES_MAKE_LIST = 'SET_VEHICLES_MAKE_LIST';
export const SET_VEHICLES_MAKE_INFO = 'SET_VEHICLES_MAKE_INFO';
